module.exports = __webpack_public_path__ + "img/icon-walkthrough.4bffa4b0.svg";